import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, NgForm } from '@angular/forms';
import { UploadService } from '../../../../../common/services/Upload.service';
import { EvsStoreService } from '../../../../../common/services/EvsStore.service';
import { Location } from '@angular/common';
import { CategoryService } from '../../../../../common/services/Category.service';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { ToastrService } from 'ngx-toastr';
import { StoreSaleService } from '../../store_manager/store-sale/services/store-sale.service';
import { PointOfSaleService } from '../product-setting/services/point_of_sale.service';
import { TranslateService } from '@ngx-translate/core';


declare var $: any;
var that;

@Component({
  selector: 'app-product-store-add',
  templateUrl: './product-store-add.component.html',
  styleUrls: ['./product-store-add.component.css']
})
export class ProductStoreAddComponent implements OnInit {
  @Input('idDetailProduct') idDetailProduct: any;
  @Output('backComponent') backComponent = new EventEmitter();
  public store: any = {};
  public message: { class: string, content: string } = null;
  public error: string = '';
  public cities: Array<any> = [];
  public districts: Array<any> = [];

  // listType = [
  //     { id: 1, value: 1, label: 'Điểm bán' },
  //     { id: 2, value: 2, label: 'Bảo hành' },
  //     { id: 3, value: 3, label: 'Điểm bán + Bảo hành' }
  // ];

  constructor(private injector: Injector,
    private _location: Location,
    private storeService: EvsStoreService,
    public addressService: EvsAddressService,
    private upload: UploadService,
    private cate: CategoryService,
    private _fb: FormBuilder,
    private storeSaleService: StoreSaleService,
    private pointOfSaleService: PointOfSaleService,
    private translate: TranslateService,
    private toastr: ToastrService) {
    that = this;
  }

  ngOnInit() {
    console.log("id", this.idDetailProduct);

    this.getCity();
    // $('#types').select2({ placeholder: "-- Chọn kiểu --", allowClear: false, width: '100%', minimumResultsForSearch: Infinity });
    $('#provinces').select2({ placeholder: this.translate.instant('SELECT_PROVINCE_CITY'), allowClear: false, width: '100%' }).on("select2:select", function (e) {
      setTimeout(() => {
        $(".select2-selection__rendered").removeAttr('title');
        var id = e.target.value;
        that.loadDistrictData(id);
      }, 100)

    });
    $('#districts').select2({ placeholder: this.translate.instant('SELECT_DISTRICT'), allowClear: false, width: '100%' })
      .on("select2:select", function (e) {
        $(".select2-selection__rendered").removeAttr('title');
      });

    this.translate.onLangChange.subscribe(() => {
      $('#provinces').select2({ placeholder: this.translate.instant('SELECT_PROVINCE_CITY'), allowClear: false, width: '100%' });
      $('#districts').select2({ placeholder: this.translate.instant('SELECT_DISTRICT'), allowClear: false, width: '100%' });
    });

    this.store.status = 1;
    console.log("id", this.store.status);
  }

  getCity() {
    this.addressService.getCities().subscribe(res => {
      let citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }

  loadDistrictData(id: number) {
    this.addressService.getDistrict({ city_id: id }).toPromise().then(res => {
      let districts = [];
      res.data.districts.forEach((c: any) => {
        districts.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.districts = districts;
    })
  }

  images = [];

  telephoneCheck(str) {
    if (str === undefined || str.length === 0) {
      return true
    }
    var patt = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im);
    return patt.test(str);
  }

  resetForm(frm: NgForm) {
    frm.resetForm();
    // $('#name').val('');
    // $('#code').val('');
    // $('#type').val('').trigger('change');
    $('#address').val('');
    $('#provinces').val('').trigger('change');
    $('#districts').val('').trigger('change');
    this.store.status = 1;
    this.store.name = '';
    this.store.code = '';
    this.message = null;
  }

  back() {
    this.backComponent.emit({
      isBack: true,
      tab: 2
    });
    //this._location.back();
  }

  onSubmit(form: NgForm) {
    let image;
    if (this.images.length == 1) {
      image = this.images[0].url
    } else {
      image = ''
    }
    this.message = null;
    let objectData = {};
    let province = $('#provinces option:selected').val();
    let district = $('#districts option:selected').val();
    console.log('status', this.store.status, this.store.phone);
    if (this.store.name.trim().length === 0) {
      this.message = { class: 'alert alert-danger', content: this.translate.instant('TEN_KHONG_DUOC_BO_TRONG') };
    } else if (!province) {
      this.message = { class: 'alert alert-danger', content: this.translate.instant('BAN_CHUA_CHON_TINHTP') };
    } else if (!district) {
      this.message = { class: 'alert alert-danger', content: this.translate.instant('BAN_CHUA_CHON_QUANHUYEN') };
    } else if (this.store.address.trim().length === 0) {
      this.message = { class: 'alert alert-danger', content: this.translate.instant('DIA_CHI_KHONG_DUOC_BO_TRONG') };
    } else if (!this.telephoneCheck(this.store.phone)) {
      this.message = { class: 'alert alert-danger', content: this.translate.instant('SO_DIEN_THOAI_CHUA_DUNG_DINH_DANG') };
    } else {
      this.processSave();
      this.store.province = $('#provinces option:selected').text();
      this.store.district = $('#districts option:selected').text();
      objectData = {
        'name': this.store.name,
        'address': this.store.address,
        'provinceId': province,
        'districtId': district,
        'phone': this.store.phone,
        'status': this.store.status,
        'image': image
      };
      this.pointOfSaleService.addNewStoreSale(this.idDetailProduct, objectData).subscribe(res => {
        if (res) {
          let error = res.error;
          if (error) {
            this.toastr.error(this.translate.instant('THO_TAC_THEM_MOI_THAT_BAI'), '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          } else {
            this.resetForm(form);
            this.toastr.success(this.translate.instant('THO_TAC_THEM_MOI_THANH_CONG'), '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
            this.backComponent.emit({
              isBack: true
            });
          }
        }
      }, error => {
        this.message = { class: "alert dark alert-danger", content: error.message };
      });
    }
    this.scrollToTop();
  }

  processSave() {
    this.message = {
      class: 'alert dark alert-info',
      content: this.translate.instant('DANG_THUC_THI')
    };
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  tusUpload = (item) => {
    const numberImages = item.target.files.length;
    console.log('numberImages', numberImages)
    if (numberImages > 2) {
      this.toastr.error('Chỉ được upload tối đa 1 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {
        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = {
              id: res.data.fileId,
              url: res.data.url,
            };
            if (this.images.length >= 1) {
              console.log(123123)
              this.toastr.error(this.translate.instant('CHI_DUOC_UPLOAD_TOI_DA_1_ANH'), '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              console.log(3412356)
              this.images.push(image2);
            }
          }
        });

      }
    }
  };

  deleteImage(id) {
    for (let i = 0; i < this.images.length; i++) {
      if (this.images[i].id === id) {
        this.images.splice(this.images.indexOf(this.images[i]), 1);
        break;
      }
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/product/product-store-add/product-store-add.component.ts